import React from "react";
import Review from "../components/review/review";

const ReviewPage = () => {
  return (
    <div>
      <Review />
    </div>
  );
};

export default ReviewPage;
